import React from "react";

import { Executor as ExecutorService } from "../../../../../../../../../../services";
import { CellContentRoot } from "../../../../../../../../../../components/LightTable";

const NoteCellContent: React.FC<NoteCellContent.Props> = ({ item }) => {
	const content = item.notes ?? "";

	return (
		<CellContentRoot alignItems="center" w="100%" h="100%">
			{content}
		</CellContentRoot>
	);
};

declare namespace NoteCellContent {
	interface Props {
		item: ExecutorService.Model;
	}
}

export default NoteCellContent;
